function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#stock-movement_svg__clip0_4332_7843)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.443 73.097h24.429-24.429z",
  fill: "#4D4D4D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.443 73.097h24.429",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.833 67.209c3.256 0 5.895-2.754 5.895-6.151s-2.64-6.151-5.895-6.151c-3.255 0-5.894 2.754-5.894 6.15 0 3.398 2.639 6.152 5.894 6.152zM53.59 67.209c4.557 0 8.252-3.856 8.252-8.612s-3.695-8.611-8.252-8.611c-4.558 0-8.253 3.855-8.253 8.611s3.695 8.612 8.252 8.612z",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.015 67.73h44.792",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.727 61.058l10.955.006M61.5 61.058h3.046c1.11 0 2.006-.94 2.006-2.1l.005-18.305c0-.326-.124-.638-.345-.87l-1.665-1.739a1.154 1.154 0 00-.833-.36h-4.23V20.97c0-.326-.124-.64-.346-.87l-2.849-2.97a1.151 1.151 0 00-.833-.361h-10.56c-2.73 0-5.458.529-7.927 1.74-6.585 3.234-10.494 9.988-10.494 17.161v2.734c0 .326-.124.64-.346.87l-6.382 6.66a1.256 1.256 0 00-.346.87v14.253h3.537M14.687 56.137H1.719c-.65 0-1.178-.551-1.178-1.23V43.835c0-.68.528-1.23 1.178-1.23h12.968",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.256 42.605v3.69c0 .68.528 1.23 1.18 1.23h2.357c.65 0 1.179-.55 1.179-1.23v-3.69M2.898 42.605V30.303c0-.68.529-1.23 1.18-1.23h10.61",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.792 29.072v3.69M59.484 37.684H31.19M53.59 37.684V21.69",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.476 35.513l8.108-4.937",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.557 42.605h-4.715M66.557 47.525h-4.715M48.87 43.835h-5.89",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.833 59.828c-.65 0-1.179.55-1.179 1.23v.01c0 .675.523 1.225 1.17 1.23.654.005 1.188-.547 1.188-1.23v-.01c0-.68-.528-1.23-1.179-1.23zM53.59 57.367c-.651 0-1.18.551-1.18 1.23v.01c0 .676.523 1.226 1.17 1.23.654.005 1.188-.547 1.188-1.23v-.01c0-.679-.528-1.23-1.178-1.23zM19.402 46.925V24.231c0-1.402-1.056-2.54-2.358-2.54-1.301 0-2.357 1.137-2.357 2.54v36.827h4.715M14.687 61.058H5.256c-.65 0-1.179-.551-1.179-1.23v-3.69",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.157 67.73h-1.285M9.671 9.962L4.54 4.607M15.967 9.151V3M8.894 16.532H3M43.158 11.378h15.428M62.443 11.378h2.572M32.602 28.103l4.32 4.434",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "stock-movement_svg__clip0_4332_7843"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .554)",
  d: "M0 0h72v75.136H0z"
})));

function SvgStockMovement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 76,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "/img/stock-movement.svg";
export { SvgStockMovement as ReactComponent };